import { html } from 'lit';
const CurveLine =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.95 6.066C14.2 4.301 16.353 3.25 20 3.25a.75.75 0 0 1 0 1.5c-3.352 0-4.95.949-5.825 2.184-.933 1.317-1.175 3.11-1.43 5.159l-.013.098c-.24 1.927-.51 4.088-1.682 5.742C9.8 19.7 7.648 20.75 4 20.75a.75.75 0 0 1 0-1.5c3.352 0 4.95-.949 5.825-2.183.933-1.318 1.175-3.11 1.43-5.16l.013-.098c.24-1.927.51-4.088 1.682-5.743" clip-rule="evenodd"/>
  </svg>
`;
export default CurveLine;
